import useCachedBatchedGet from './useGetCachedDocIdBatched';

export default function useUser(userId) {
  const userData = useCachedBatchedGet('services/data/users/info', 10, { idField: 'id' })(userId);

  return userData;
}
